export default __webpack_public_path__ + "static/media/download-bg.536caae9.jpeg";